import { render, staticRenderFns } from "./PermissionsFilter.vue?vue&type=template&id=1203415c"
import script from "./PermissionsFilter.vue?vue&type=script&lang=js"
export * from "./PermissionsFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports